module.exports = __webpack_public_path__ + "img/icon_features_pause2_hover.75dab8f3.svg";